// this is an autogenerated file from App/Account/Content/Settings/Content/CommsEmail/Emails/Emails/Content/Email/Default/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_CommsEmail_Emails_Emails_Content_Email_Default($location_id: uuid!, $sender_id: uuid!) {
  delete_comms_defaults(
    where: { location_id: { _eq: $location_id }, type: { _eq: "email" } }
  ) {
    affected_rows
  }

  insert_comms_defaults_one(
    object: { sender_id: $sender_id, location_id: $location_id, type: "email" }
  ) {
    id
  }
}

`